import { FwCssVariableColor, fwCssVariableColorPrefix } from './design-system.model'

export const isFwCssVariableColor = (color: string): color is FwCssVariableColor =>
  color.startsWith(fwCssVariableColorPrefix)
